import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleAnalytics } from '/app/node_modules/@nuxt/scripts/dist/runtime/registry/google-analytics.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleAnalytics = useScriptGoogleAnalytics({})
    return { provide: { $scripts: { googleAnalytics } } }
  }
})